module.exports = __webpack_public_path__ + "static/assets/84ae3f18ea4b525c2bf1a0bc7dae5d5f.png";